import React, { useContext } from 'react';
import { makeStyles } from 'tss-react/mui';
import Button from '@ui/Button';
import Icon from '@ui/Icon';
import { StudioClipContext } from '../StudioClip';
import StudioClipAction, { StudioClipActionProps } from './StudioClipAction';
import StudioClipActionTooltip from './StudioClipActionTooltip';

export enum RegenerateType {
  script = 'script',
  cues = 'cues',
}

interface StudioClipActionRegenerateProps extends StudioClipActionProps {
  regenerateType?: RegenerateType;
}

const useStyles = makeStyles()(theme => ({
  iconButton: {
    width: 'fit-content',
    borderRadius: theme.spacing(0.5),
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

const StudioClipActionRegenerate = (props: StudioClipActionRegenerateProps) => {
  const { regenerateType = RegenerateType.script, onClick, ...rest } = props;
  const { clip, breakpoint } = useContext(StudioClipContext);
  const { classes } = useStyles();

  if (!clip) return null;

  const label = `Repopulate ${regenerateType}`;

  return breakpoint === 'xs' ? (
    <StudioClipAction.Mobile
      {...rest}
      menuItemText="Re-take"
      aria-label={label}
    >
      <Icon className={classes.iconButton} type="type" />
    </StudioClipAction.Mobile>
  ) : (
    <StudioClipActionTooltip placement="bottom" title={label}>
      <Button
        variant="icon"
        className={classes.iconButton}
        aria-label={label}
        onClick={onClick}
      >
        <Icon type="type" />
      </Button>
    </StudioClipActionTooltip>
  );
};

export default StudioClipActionRegenerate;
